import '@castleio/castle-js/dist/castle.browser.js';
if (import.meta.env.VITE_CASTLE_PUBLISHABLE_KEY) {
  Castle.configure({ pk: import.meta.env.VITE_CASTLE_PUBLISHABLE_KEY });
}
